<div class="breadcrumb section">
    <div class="row noMargin relative">
        <div class="sub-nav breadcrumbs col-12 col-sm-12 col-md-12 col-lg-12" role="navigation"
            aria-label="Breadcrumb">
            <ul class="nav">
                <li *ngIf="pageFlags?.isCouponsDealsPage || pageFlags?.isBonusPathPage || pageFlags?.isDiscoveryPage">
                    <a class="breadcrumb-svg-anchor-padding  body-s" href="/foru.html" aria-current="false">
                        <span class="svg-icon svg-icon-Arrow_left_breadcrumb breadcrumb-svg-arrow " role="img"
                            aria-hidden="true"></span>
                        {{ displayableBannerName }} for U
                    </a>
                </li>
                <li class="active hide-root-title body-s body-s--semi-bold" aria-current="page" *ngIf="pageFlags?.isBonusPathPage || pageFlags?.isCouponsDealsPage || pageFlags?.isDiscoveryPage">
                   <a class="breadcrumb-svg-anchor-padding body-s body-s--semi-bold" href="javascript:void(0)" tabindex="-1" style="pointer-events: none;">
                        <span class="svg-icon svg-icon-Arrow_left_breadcrumb breadcrumb-svg-arrow hide-back-arrow"
                            role="img" aria-hidden="true"></span>
                        {{ pageFlags.isBonusPathPage ? 'Bonus Path' : pageFlags.isDiscoveryPage ? 'Discover' : 'Deals+' }}
                    </a>
                </li>
         
                <li class="back-button-con" *ngIf="pageFlags?.isOfferDetailsPage">
                    <a class="back-button-pdp" aria-label="Back to previous page" data-icon="❮" (click)="goBackClick()">
                        <span class="back-button-pdp-text">Back</span>
                        <span class="sr-only back-button-ada-reader"></span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
